<template>
    <div class="flex-1">
      <CheckBoxCardsComponent
        v-model="localModelValue"
        :options="[
          { id: 'undefined', name: $t('attributes.undefined') },
          ...document_delivery_preferences
        ]"
        track-by="id"
        attribute-label="name"
        :edition-mode="editionMode"
        :size="size"
      />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WalkmanButton from '@c/WalkmanButton.vue'
import CheckBoxCardsComponent from '@c/BaseFormComponent/CheckBoxCardsComponent.vue'

export default {
  name: 'SelectDocumentDeliveryPreference',
  components: { CheckBoxCardsComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
  },
  emits: ['update:modelValue'],

  computed: {
    ...mapGetters({
      document_delivery_preferences:
        'metadata/getPersonCommunicationMethodePreferences'
    }),
    localModelValue: {
      get() {
        console.log(this.modelValue)
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  mounted() {
    if (!this.localModelValue || this.localModelValue.length === 0) {
      this.localModelValue = ['undefined']
    }
  }
}
</script>
